import axios from "axios";
import { Loading } from 'element-ui';
const requests = axios.create({
    baseURL: "https://r9.ruijiiot.com.cn/official",
    timeout: 50000,


});
let loadingInstance = ''



requests.interceptors.request.use((config) => {

    loadingInstance = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    config.headers.lang = localStorage.getItem('change-language') || 'zh'
    return config
}, (err) => {

    return Promise.reject(err)
})

requests.interceptors.response.use((response) => {

    loadingInstance.close();
    return response.data
}, (err) => {


    return Promise.reject(err)
})
export default requests;